import * as React from "react";
import ISMSubmenu, { TSMSubmenu } from "./ISMSubmenu";
import { NavLink } from "react-router-dom";
import SubmenuIcon from "./../SubmenuIcon/SubmenuIcon";
import Notification from "@appComponents/Notification/Notification";
import { classNames as cn } from "@features/utils/reactFunctions";

import * as style from "./SMSubmenuStyle.module.scss";

export default class SMSubmenu extends React.Component<ISMSubmenu, TSMSubmenu> {
  state: TSMSubmenu = {
    open: false,
  };

  closeMenu = () => {
    this.setState({
      open: false,
    });
  };

  toggleMenu = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    const { userSignedIn, isUk } = this.props;

    return (
      <React.Fragment>
        <div className={cn(style.companySubmenu, style.newSubmenu)}>
          <ul
            className={[
              style.companyMenu,
              this.state.open ? style.companyMenuOpen : null,
            ].join(" ")}
          >
            <React.Fragment>
              {!isUk && (
                <li className={style.menuItem}>
                  <NavLink
                    activeClassName={style.active}
                    className={style.link}
                    exact={true}
                    to={"/market"}
                    onClick={this.closeMenu}
                  >
                    Overview
                    <SubmenuIcon icon="overviewshares" />
                  </NavLink>
                </li>
              )}
              <li className={style.menuItem}>
                <NavLink
                  activeClassName={style.active}
                  className={style.link}
                  to={"/market/spvs"}
                  onClick={this.closeMenu}
                >
                  Market
                  <SubmenuIcon icon="buyshares" />
                </NavLink>
              </li>
              {userSignedIn && (
                <React.Fragment>
                  <li className={style.menuItem}>
                    <NavLink
                      activeClassName={style.active}
                      className={style.link}
                      exact={true}
                      to={"/market/my_trades"}
                      onClick={this.closeMenu}
                    >
                      My trades
                      <SubmenuIcon icon="mytrades" />
                    </NavLink>
                  </li>
                  <li className={style.menuItem}>
                    <NavLink
                      activeClassName={style.active}
                      className={style.link}
                      exact={true}
                      to={"/market/my_orders"}
                      onClick={this.closeMenu}
                    >
                      My Orders
                      <SubmenuIcon icon="myorders" />
                    </NavLink>
                  </li>
                </React.Fragment>
              )}
            </React.Fragment>
          </ul>
          <div
            id="j-toggle-btn"
            className={[
              style.linksToogle,
              this.state.open ? style.linksToogleOpen : null,
            ].join(" ")}
            onClick={this.toggleMenu}
          />
        </div>
        <Notification />
      </React.Fragment>
    );
  }
}
